import {
    CLEAR_ALARMS,
    HIGHEST_SEVERITY,
    QUERY_STOPPED,
    SECOND_HIGHEST_SEVERITY,
    UPDATE_ALERTS,
    UPDATE_ASSET_ID,
    UPDATE_CURVES,
    UPDATE_RULES_SERVICE,
    UPDATE_SUBSCRIPTION
} from '../constants'
import { setGlobalAlert } from '.'

const subscribeHandler = (dispatch, getState) => batch => {
    const newBatch = []
    const currentBatch = getState().dashboardReducer.batch
    const closed = []
    let modified = false

    ;[].concat(batch.data).forEach(e => {
        const event = e.data || e

        if (event.type === 'event') {
            event.content.forEach(alarm => {
                if (!alarm || alarm.__type?.toLowerCase() !== 'alarm') return

                if (alarm.status === 'open' || alarm.status === 'severity_increase') {
                    modified = true
                    newBatch.push(alarm)
                } else if (alarm.status === 'closed') {
                    modified = true
                    closed.push(alarm)
                }
            })
        } else if (event.type === 'stop' || event.type === 'destroy') {
            if (event.reason === 'Error') {
                console.error('Error on open alarms query:', event.message)
            } else {
                dispatch({ type: QUERY_STOPPED })
            }
        }
    })

    if (modified) {
        const newBatchDeduplicated = []
        newBatch.forEach(a => {
            if (closed.find(c => c.id === a.id)) return

            const insideBatch = newBatchDeduplicated.findIndex(alarm => alarm.id === a.id)
            if (insideBatch >= 0) {
                if (
                    (newBatchDeduplicated[insideBatch].severity === SECOND_HIGHEST_SEVERITY &&
                        a.severity === HIGHEST_SEVERITY) ||
                    (newBatchDeduplicated[insideBatch].severity === a.severity &&
                        newBatchDeduplicated[insideBatch].timestamp < a.timestamp)
                ) {
                    newBatchDeduplicated[insideBatch] = a
                }
            } else {
                newBatchDeduplicated.push(a)
            }
        })

        dispatch({
            type: UPDATE_ALERTS,
            batch: [
                ...newBatchDeduplicated,
                ...currentBatch.filter(
                    alarm => !closed.find(c => c.id === alarm.id) && !newBatchDeduplicated.find(a => a.id === alarm.id)
                )
            ]
        })
    }
}

export default (assetName, selectedUnitSetId, abortController) => {
    return (dispatch, getState) => {
        return fetch(
            `/services/plugin-channel-alarms/alarm-rules/open-alarms?wellName=${encodeURIComponent(assetName)}${
                selectedUnitSetId ? '&selectedUnitSetId=' + selectedUnitSetId : ''
            }`,
            { signal: abortController.signal }
        )
            .then(r => {
                if (r.ok) {
                    return r.json()
                }

                return Promise.reject(new Error('Could not get channel to listen for open alarms'))
            })
            .then(({ assetId, channels, standardCurves, calculatedCurves, assetRules }) => {
                if (!assetId && assetId !== 0) {
                    dispatch({ type: CLEAR_ALARMS })
                    console.error('No asset id returned from open alarms request')
                }

                dispatch({ type: UPDATE_ASSET_ID, id: assetId })

                if (!standardCurves || !calculatedCurves) {
                    const missingChannelType =
                        !standardCurves && !calculatedCurves ? '' : !calculatedCurves ? 'calculated ' : 'standard '

                    console.error(`No ${missingChannelType}channels data returned from open alarms request`)
                    dispatch(setGlobalAlert(`Error getting ${missingChannelType}channels data`, false))
                } else {
                    dispatch({
                        type: UPDATE_CURVES,
                        curves: {
                            ...standardCurves,
                            ...Object.keys(calculatedCurves).reduce(
                                (obj, ch) => ({
                                    ...obj,
                                    [ch]: { ...calculatedCurves[ch], calculated: true }
                                }),
                                {}
                            )
                        }
                    })
                }

                if (assetRules) {
                    dispatch({ type: UPDATE_RULES_SERVICE, rules: assetRules })
                }

                if (!channels.length || !channels[0].channel) {
                    console.error('No channel available to listen for open alarms')

                    return
                } else if (!channels[0].channel || !channels[1].channel) {
                    console.error('Missing channel to listen for open alarms')

                    return
                }

                const subscription = channels
                    .filter(c => c.channel)
                    .map(c => {
                        try {
                            return window.cometd.subscribe(c.channel, subscribeHandler(dispatch, getState))
                        } catch (e) {
                            console.error('Error subscribing to channel', c, e)

                            return null
                        }
                    })
                    .filter(s => s)

                if (subscription && Array.isArray(subscription)) {
                    dispatch({ type: UPDATE_SUBSCRIPTION, subscription })
                }
            })
            .catch(err => {
                if (err.name !== 'AbortError') {
                    dispatch(setGlobalAlert('Error starting alarm query', false))
                    console.error('Error starting alarm query:', err)
                }
            })
    }
}
